import { APColumn, APExpanded, APScrollView } from 'ap-components';
import React from 'react'

export default function MandateScrollContainer({ scrollContent, actions }: { scrollContent: React.ReactNode, actions?: React.ReactNode }) {
    return (
        <APColumn mainAxisSize="max" crossAxisAlignment="center" >
            <APExpanded>
                <APColumn mainAxisAlignment="spaceBetween" style={{ width: "min(600px, 100%)", padding: "0 8px 0 16px" }} mainAxisSize="max" gap="16px">
                    <APExpanded>
                        <APScrollView style={{ width: "100%" }}>
                            <APColumn crossAxisAlignment="stretch" style={{ paddingRight: "8px", paddingBottom: actions ? 0 : "16px" }}>
                                {scrollContent}
                            </APColumn>
                        </APScrollView>
                    </APExpanded>
                    {
                        actions &&
                        <APColumn crossAxisAlignment="stretch" style={{ paddingBottom: "16px" }}>
                            {actions}
                        </APColumn>
                    }
                </APColumn>
            </APExpanded >
        </APColumn >
    )
}
